

















































import { computed, defineNuxtComponent, ref } from '~/utils/nuxt3-migration'
import { capitalizeString } from '~/utils/string'
import { useNamespacedStore } from '~/compositions/store'
import { useI18n } from '~/compositions/i18n'
import {
  DEALER_SITE_NS,
  DealerSiteState
} from '~/store/modules/shared/dealers/site/state'
import { SET_ACTIVE_OUTLET_ID } from '~/store/modules/shared/dealers/site/mutation-types'
import DealerSiteLayoutService from '~/services/dealers/site/DealerSiteLayoutService'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import OutletCardContent from '~/components/car/dealers/site/outlet/OutletCardContent.vue'
import CContactForm from '~/components/shared/configurable/CContactForm.vue'

export default defineNuxtComponent({
  components: {
    CCard,
    OutletCardContent,
    CContactForm
  },
  setup() {
    const { state, getters, commit } = useNamespacedStore<DealerSiteState>(
      DEALER_SITE_NS
    )
    const { tc } = useI18n()

    const showContactForm = ref(true)
    const outlets = computed(() => state.outlets)
    const websiteId = computed(() => state.websiteId)
    const activeOutletId = computed(() => state.activeOutletId)
    const firstOutlet = computed(() => getters('firstOutlet'))
    const activePage = computed(() => getters('activePage'))
    const componentShouldRenderPage = computed(() =>
      getters('componentShouldRenderPage')
    )
    const storeTitle = computed(() =>
      capitalizeString(tc('store | stores', outlets.value.size))
    )
    const outletOptions = computed(() =>
      Array.from(outlets.value).map(([id, outlet]) => ({
        label: outlet.displayName,
        value: id
      }))
    )

    function setActiveOutletId(id: string) {
      commit(SET_ACTIVE_OUTLET_ID, id)
    }
    function cannotReceiveMessages() {
      showContactForm.value = false
    }

    return {
      showContactForm,
      outlets,
      websiteId,
      activeOutletId,
      firstOutlet,
      activePage,
      componentShouldRenderPage,
      storeTitle,
      outletOptions,
      setActiveOutletId,
      cannotReceiveMessages
    }
  },
  head() {
    const [dealerSiteLayoutService] = this.$deps(DealerSiteLayoutService)
    const head = {}
    dealerSiteLayoutService.setPageTitle(head, this.$t('contact').toString())
    return head
  }
})
